import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import NATIVE_FEATURE_FLAG from '@/constants/featureFlags';
import WorkersV2 from '../WorkersV2';
import GravyWorkers from './index';

// GRAVY-10436: one URL, two pages. The flag map is warmed at login, so
// `loading` is almost always false here; when it is not, render nothing rather
// than flash the legacy page and then swap.
const GravyWorkersGate = () => {
  const { variant, loading } = useFeatureFlag(
    NATIVE_FEATURE_FLAG.GravyWorkersActivation,
  );
  if (loading) return null;
  return variant === 'on' ? <GravyWorkers /> : <WorkersV2 />;
};

export default GravyWorkersGate;
